import { FileAttachment, TextDirection } from 'interface';

export interface __ScoreRatingProps {
    icon: __ScoreRatingIcon;
    label?: string;
    value?: number;
    counter?: number;
    hint?: string;
    image?: FileAttachment;
    required?: boolean;
    max?: number;
    labelColor?: string;
    color?: string;
    dir?: TextDirection;
    defaultValue?: number;
    onChange?: (e?: number | null) => void;
}

export interface __ScoreRatingRef {
    getValue: () => number | null;
    setError: (text: string) => void;
}

export enum __ScoreRatingIcon {
    star = 1,
    flag = 2,
    circle = 3,
    thumb_up = 4,
    heart = 5,
    person = 6,
}
